// ReSharper disable InconsistentNaming
export const CANCEL_RETURN = "CANCEL_RETURN";
export const CANCEL_PAYMENT = "CANCEL_PAYMENT";
export const RETRIEVE_CANCELLED_DATA_ACTION = "RETRIEVE_CANCELLED_DATA_ACTION";
export const RETRIEVE_CANCELLED_DATA_SUCCESS_ACTION = "RETRIEVE_CANCELLED_DATA_SUCCESS_ACTION";
export const CANCELLED_ERROR = "CANCELLED_ERROR";
export const CANCELLED_PAYMENT_ERROR = "CANCELLED_PAYMENT_ERROR";
// ReSharper restore InconsistentNaming
